// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"802":"d2ecf7cc","1083":"d2ecf7cc","1953":"dc1fcfec","5295":"12364756","7068":"dd35f1ec"}[chunkId] + ".chunk.css";
};